import { useEffect, useState } from 'react'
import QR from 'qrcode'

export function QRCode({
  value,
  size = 160,
}: {
  value: string
  size?: number
}) {
  const [src, setSrc] = useState('')
  const [failed, setFailed] = useState(false)
  useEffect(() => {
    let active = true
    setSrc('')
    setFailed(false)
    QR.toDataURL(value, { width: size, margin: 2 })
      .then((url) => {
        if (active) setSrc(url)
      })
      .catch(() => {
        if (active) setFailed(true)
      })
    return () => {
      active = false
    }
  }, [value, size])
  return src ? (
    <img src={src} width={size} height={size} alt="驗證器設定二維碼" />
  ) : (
    <span role="status">
      {failed ? '二維碼生成失敗，請使用設定密鑰' : '正在生成二維碼...'}
    </span>
  )
}
